export function joinConjunction(items: string[]): string {
  const formatter = new Intl.ListFormat('de', {
    style: 'long',
    type: 'conjunction',
  })
  return formatter.format(items)
}
